import { CHANGE_LANGUE } from '../actionTypes';

const changeLangue = (langue) => async (dispatch, getState) => {
    dispatch({ type: CHANGE_LANGUE, payload: langue });
}

export { changeLangue };